export default {
  methods: {
    disableScroll() {
      window.scrollTo(0, 0);
    },
  }
};
